import { FlexCenter } from '../../App.styled';
import styled from 'styled-components';

export const ModalWrapper = styled(FlexCenter)`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    align-content: center;
    background-color: ${({ theme }) => theme?.colors?.grey[300]};
`;

export const ModalContentWrapper = styled.div`
    display: flex;
    height: 23.875rem;
    width: 37.5rem;
    border-radius: 2px;
    background-color: ${({ theme }) => theme?.colors?.white};
    box-shadow: 2px 4px 28px 2px rgba(0, 0, 0, 0.5);
    flex-direction: column;

    @media screen and (max-width: 425px) {
        width: 18.75rem;
    }
`;

export const CloseBtn = styled.div`
    display: flex;
    align-self: flex-end;
    position: absolute;
    margin: 10px;
    height: 41px;
    box-sizing: border-box;
    cursor: pointer;
    opacity: 0.5;
`;

export const ModalContent = styled(FlexCenter)`
    flex-direction: column;
    flex: 1;
`;

export const TextWrapper = styled.div`
    margin: 19px 10px 41px 10px;
    text-align: center;
`;

export const AlertIconWrapper = styled.div`
    height: 3.188rem;
    width: 3.75rem;
`;
